import { cn } from "@kyan/ui";

import { useMarketIndexPrice } from "#/store/app/indexPrices/marketIndexPrice";
import { getStrikePrecision } from "#/utils/getStrikePrecision";
import { formatCurrency } from "#/utils/valueFormatters";

interface PriceIndicatorProps {
  attachToBottom?: boolean;
}

export const PriceIndicator: React.FC<PriceIndicatorProps> = ({
  attachToBottom = false,
}) => {
  const { marketIndexPrice } = useMarketIndexPrice();

  return (
    <div
      className={cn(
        "via-primary absolute h-px w-full -translate-y-px bg-gradient-to-r from-[rgba(32,43,140,0.00)] to-[rgba(32,43,140,0.00)]",
        {
          "top-0": !attachToBottom,
          "bottom-0 translate-y-px": attachToBottom,
        },
      )}
    >
      <button className="font-grotesk from-primary text-xxs absolute inset-x-0 mx-auto h-6 w-14 -translate-y-1/2 rounded-sm bg-gradient-to-r to-[#203096] leading-[9px] text-white shadow-[0px_0px_8px_0px_#ADB9FF] dark:shadow-[0px_0px_8px_0px_rgba(0,0,0,0.90)]">
        <div className="absolute inset-0 rounded-sm bg-white/[8%]">
          <div className="from-primary absolute inset-px flex items-center justify-center rounded-sm bg-gradient-to-r to-[#203096]">
            {formatCurrency(marketIndexPrice, {
              precision: getStrikePrecision(marketIndexPrice),
            })}
          </div>
        </div>
      </button>
    </div>
  );
};
